<template>
  <div class="feedback-management">
    <div class="header">
      <h2>题目反馈管理</h2>
      <div class="statistics">
        <el-tag type="warning">待处理: {{ statistics.pending || 0 }}</el-tag>
        <el-tag type="primary">处理中: {{ statistics.processing || 0 }}</el-tag>
        <el-tag type="success">已处理: {{ statistics.handled || 0 }}</el-tag>
        <el-tag type="info">已忽略: {{ statistics.ignored || 0 }}</el-tag>
      </div>
    </div>

    <!-- 筛选条件 -->
    <div class="filter-bar">
      <el-select v-model="filterStatus" placeholder="按状态筛选" clearable @change="loadFeedbackList">
        <el-option label="处理状态" :value="null"></el-option>
        <el-option label="待处理" :value="0"></el-option>
        <el-option label="处理中" :value="1"></el-option>
        <el-option label="已处理" :value="2"></el-option>
        <el-option label="已忽略" :value="3"></el-option>
      </el-select>

      <el-select v-model="filterType" placeholder="按类型筛选" clearable style="margin-left: 10px">
        <el-option label="题目类型" :value="null"></el-option>
        <el-option label="题干问题" :value="1"></el-option>
        <el-option label="选项问题" :value="2"></el-option>
        <el-option label="图片问题" :value="3"></el-option>
        <el-option label="解析问题" :value="4"></el-option>
        <el-option label="答案问题" :value="5"></el-option>
        <el-option label="其他问题" :value="6"></el-option>
      </el-select>

      <el-button type="primary" icon="el-icon-refresh" @click="loadFeedbackList" style="margin-left: 10px">
        刷新
      </el-button>
    </div>

    <!-- 反馈列表 -->
    <el-table
      :data="feedbackList"
      v-loading="loading"
      style="width: 100%; margin-top: 20px"
      border
    >
      <el-table-column prop="id" label="ID" width="80"></el-table-column>

      <el-table-column prop="amcQuestionId" label="题目ID" width="100">
        <template slot-scope="scope">
          <el-link type="primary" @click="viewQuestion(scope.row.amcQuestionId)">
            #{{ scope.row.amcQuestionId }}
          </el-link>
        </template>
      </el-table-column>

      <el-table-column prop="feedbackType" label="反馈类型" width="120">
        <template slot-scope="scope">
          <el-tag :type="getTypeTagType(scope.row.feedbackType)" size="small">
            {{ getTypeName(scope.row.feedbackType) }}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column prop="content" label="问题描述" min-width="200" show-overflow-tooltip></el-table-column>

      <el-table-column prop="userName" label="反馈人" width="120"></el-table-column>

      <el-table-column prop="priority" label="优先级" width="100">
        <template slot-scope="scope">
          <el-tag :type="getPriorityType(scope.row.priority)" size="small">
            {{ getPriorityName(scope.row.priority) }}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column prop="status" label="状态" width="100">
        <template slot-scope="scope">
          <el-tag :type="getStatusType(scope.row.status)" size="small">
            {{ getStatusName(scope.row.status) }}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column prop="createTime" label="提交时间" width="160">
        <template slot-scope="scope">
          {{ formatTime(scope.row.createTime) }}
        </template>
      </el-table-column>

      <el-table-column label="操作" width="180" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="openHandleDialog(scope.row)">
            处理
          </el-button>
          <el-button size="mini" @click="viewDetail(scope.row)">
            详情
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 处理对话框 -->
    <el-dialog title="处理反馈" :visible.sync="handleDialogVisible" width="900px">
      <el-form :model="handleForm" label-width="100px" v-loading="questionLoading">
        <el-form-item label="反馈类型">
          <el-tag>{{ getTypeName(currentFeedback.feedbackType) }}</el-tag>
        </el-form-item>

        <el-form-item label="问题描述">
          <div>{{ currentFeedback.content }}</div>
        </el-form-item>

        <el-form-item label="反馈人">
          <span>{{ currentFeedback.userName }}</span>
        </el-form-item>

        <el-form-item label="处理状态">
          <el-radio-group v-model="handleForm.status" :disabled="detailMode">
            <el-radio :label="1">处理中</el-radio>
            <el-radio :label="2">已处理</el-radio>
            <el-radio :label="3">已忽略</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="处理备注">
          <el-input
            type="textarea"
            v-model="handleForm.handlerNote"
            :rows="4"
            :disabled="detailMode"
            placeholder="请输入处理备注"
          ></el-input>
        </el-form-item>

        <el-divider content-position="left">题目详情修改</el-divider>

        <el-form-item label="题目ID">
          <el-input v-model="questionForm.id" disabled></el-input>
        </el-form-item>

        <el-form-item label="题干（中文）">
          <el-input v-model="questionForm.contentCn" type="textarea" :rows="4" :disabled="detailMode"></el-input>
        </el-form-item>

        <el-form-item label="题干（英文）">
          <el-input v-model="questionForm.contentEn" type="textarea" :rows="4" :disabled="detailMode"></el-input>
        </el-form-item>

        <el-form-item label="选项（中文）">
          <el-input
            v-model="questionForm.optionsCn"
            type="textarea"
            :rows="4"
            :disabled="detailMode"
            placeholder="格式：(A) 选项1;(B) 选项2;(C) 选项3;(D) 选项4;(E) 选项5"
          ></el-input>
        </el-form-item>

        <el-form-item label="选项（英文）">
          <el-input
            v-model="questionForm.optionsEn"
            type="textarea"
            :rows="4"
            :disabled="detailMode"
            placeholder="Format: (A) Option1;(B) Option2;(C) Option3;(D) Option4;(E) Option5"
          ></el-input>
        </el-form-item>

        <el-form-item label="答案">
          <el-input v-model="questionForm.answer" :disabled="detailMode" placeholder="如：A 或 B 或 123"></el-input>
        </el-form-item>

        <el-form-item label="解析（中文）">
          <el-input v-model="questionForm.analysisCn" type="textarea" :rows="3" :disabled="detailMode"></el-input>
        </el-form-item>

        <el-form-item label="解析（英文）">
          <el-input v-model="questionForm.analysisEn" type="textarea" :rows="3" :disabled="detailMode"></el-input>
        </el-form-item>

        <el-form-item label="图片">
          <div style="display: flex; gap: 10px; align-items: center;">
            <el-input :value="getPrimaryImagePath(questionForm)" placeholder="题目相关图片链接" readonly></el-input>
            <el-upload
              action=""
              :show-file-list="false"
              :http-request="uploadQuestionImage"
              :before-upload="beforeQuestionImageUpload"
              :disabled="detailMode"
            >
              <el-button type="primary" plain :loading="imageUploading">上传图片</el-button>
            </el-upload>
            <el-button v-if="getPrimaryImagePath(questionForm) && !detailMode" type="danger" plain @click="removeQuestionImage">删除图片</el-button>
          </div>
          <img v-if="getPrimaryImagePath(questionForm)" :src="resolveImageUrl(getPrimaryImagePath(questionForm))" style="max-width: 300px; margin-top: 10px;" />
        </el-form-item>

        <el-form-item label="知识点">
          <el-select v-model="questionForm.knowledge" filterable clearable placeholder="请选择知识点" style="width: 100%" :disabled="detailMode">
            <el-option
              v-for="item in flattenedKnowledgeOptions"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="年份">
          <el-input v-model="questionForm.year" :disabled="detailMode"></el-input>
        </el-form-item>

        <el-form-item label="难度">
          <el-input v-model="questionForm.difficulty" :disabled="detailMode" placeholder="如：Easy, Medium, Hard"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="handleDialogVisible = false">{{ detailMode ? '关 闭' : '取 消' }}</el-button>
        <el-button v-if="!detailMode" type="primary" @click="submitHandle" :loading="submitting">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 题目编辑对话框 -->
    <el-dialog title="编辑题目" :visible.sync="editQuestionDialogVisible" width="800px">
      <el-form :model="questionForm" label-width="120px" v-loading="questionLoading">
        <el-form-item label="题目ID">
          <el-input v-model="questionForm.id" disabled></el-input>
        </el-form-item>

        <el-form-item label="题干（中文）">
          <el-input v-model="questionForm.contentCn" type="textarea" :rows="4"></el-input>
        </el-form-item>

        <el-form-item label="题干（英文）">
          <el-input v-model="questionForm.contentEn" type="textarea" :rows="4"></el-input>
        </el-form-item>

        <el-form-item label="选项（中文）">
          <el-input
            v-model="questionForm.optionsCn"
            type="textarea"
            :rows="4"
            placeholder="格式：(A) 选项1;(B) 选项2;(C) 选项3;(D) 选项4;(E) 选项5"
          ></el-input>
        </el-form-item>

        <el-form-item label="选项（英文）">
          <el-input
            v-model="questionForm.optionsEn"
            type="textarea"
            :rows="4"
            placeholder="Format: (A) Option1;(B) Option2;(C) Option3;(D) Option4;(E) Option5"
          ></el-input>
        </el-form-item>

        <el-form-item label="答案">
          <el-input v-model="questionForm.answer" placeholder="如：A 或 B 或 123"></el-input>
        </el-form-item>

        <el-form-item label="解析（中文）">
          <el-input v-model="questionForm.analysisCn" type="textarea" :rows="3"></el-input>
        </el-form-item>

        <el-form-item label="解析（英文）">
          <el-input v-model="questionForm.analysisEn" type="textarea" :rows="3"></el-input>
        </el-form-item>

        <el-form-item label="图片">
          <div style="display: flex; gap: 10px; align-items: center;">
            <el-input :value="getPrimaryImagePath(questionForm)" placeholder="题目相关图片链接" readonly></el-input>
            <el-upload
              action=""
              :show-file-list="false"
              :http-request="uploadQuestionImage"
              :before-upload="beforeQuestionImageUpload"
            >
              <el-button type="primary" plain :loading="imageUploading">上传图片</el-button>
            </el-upload>
            <el-button v-if="getPrimaryImagePath(questionForm)" type="danger" plain @click="removeQuestionImage">删除图片</el-button>
          </div>
          <img v-if="getPrimaryImagePath(questionForm)" :src="resolveImageUrl(getPrimaryImagePath(questionForm))" style="max-width: 300px; margin-top: 10px;" />
        </el-form-item>

        <el-form-item label="知识点">
          <el-select v-model="questionForm.knowledge" filterable clearable placeholder="请选择知识点" style="width: 100%">
            <el-option
              v-for="item in flattenedKnowledgeOptions"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="年份">
          <el-input v-model="questionForm.year"></el-input>
        </el-form-item>

        <el-form-item label="难度">
          <el-input v-model="questionForm.difficulty" placeholder="如：Easy, Medium, Hard"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="editQuestionDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveQuestion" :loading="savingQuestion">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getAllFeedback, getFeedbackByStatus, handleFeedback, getStatistics } from '@/api/amcQuestionFeedback'
import { getQuestionById, updateQuestion } from '@/api/courseQuestion'
import { listGeneralKnowledgeTree } from '@/api/knowledge'
import { uploadToBucket } from '@/api/file'

export default {
  name: 'FeedbackManagement',
  computed: {
    flattenedKnowledgeOptions() {
      const result = []
      const walk = (nodes, prefix = '') => {
        ;(nodes || []).forEach(node => {
          const id = node.id != null ? Number(node.id) : null
          const name = String(node.content || node.name || node.title || '').trim()
          if (!id || !name) return
          const label = prefix ? `${prefix} / ${name}` : name
          result.push({ id, label })
          if (Array.isArray(node.children) && node.children.length) {
            walk(node.children, label)
          }
        })
      }
      walk(this.knowledgeTree, '')
      return result
    }
  },
  data() {
    return {
      loading: false,
      submitting: false,
      feedbackList: [],
      filterStatus: null,
      filterType: null,
      statistics: {},
      handleDialogVisible: false,
      detailMode: false,
      currentFeedback: {},
      handleForm: {
        feedbackId: null,
        status: 2,
        handlerNote: ''
      },
      // 题目编辑相关
      editQuestionDialogVisible: false,
      questionLoading: false,
      savingQuestion: false,
      imageUploading: false,
      knowledgeTree: [],
      questionForm: {
        id: null,
        contentCn: '',
        contentEn: '',
        optionsCn: '',
        optionsEn: '',
        answer: '',
        analysisCn: '',
        analysisEn: '',
        image_paths: '[]',
        knowledge: '',
        year: '',
        difficulty: ''
      }
    }
  },
  mounted() {
    this.loadFeedbackList()
    this.loadStatistics()
    this.loadKnowledgeTree()
  },
  methods: {
    async loadKnowledgeTree() {
      try {
        const res = await listGeneralKnowledgeTree(19)
        this.knowledgeTree = Array.isArray(res?.data) ? res.data : []
      } catch (error) {
        this.knowledgeTree = []
      }
    },
    normalizeQuestionForm(data) {
      const next = { ...(data || {}) }
      if (Array.isArray(next.image_paths)) {
        next.image_paths = JSON.stringify(next.image_paths)
      } else if (!next.image_paths && next.image) {
        next.image_paths = JSON.stringify([next.image])
      } else if (!next.image_paths) {
        next.image_paths = '[]'
      }
      const rawKnowledge = next.knowledgeId != null ? next.knowledgeId : next.knowledge
      if (rawKnowledge !== undefined && rawKnowledge !== null && rawKnowledge !== '') {
        const matchedById = this.flattenedKnowledgeOptions.find(item => String(item.id) === String(rawKnowledge))
        const matchedByName = this.flattenedKnowledgeOptions.find(item => item.label === String(rawKnowledge) || item.label.endsWith(` / ${String(rawKnowledge)}`) || String(rawKnowledge) === item.label.split(' / ').pop())
        if (matchedById) {
          next.knowledge = matchedById.id
        } else if (matchedByName) {
          next.knowledge = matchedByName.id
        }
      }
      return next
    },
    getPrimaryImagePath(form) {
      const raw = form && form.image_paths
      if (Array.isArray(raw)) {
        return raw[0] || ''
      }
      if (typeof raw === 'string') {
        const text = raw.trim()
        if (!text) return ''
        try {
          const parsed = JSON.parse(text)
          if (Array.isArray(parsed)) {
            return parsed[0] || ''
          }
        } catch (e) {
          return text
        }
      }
      return ''
    },
    normalizeStoredImagePath(value) {
      let imagePath = String(value || '').trim()
      const bucket = 'amc-question-test'
      if (!imagePath) return ''
      if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
        try {
          const url = new URL(imagePath)
          imagePath = url.pathname
        } catch (e) {
          return imagePath
        }
      }
      if (!imagePath.startsWith('/')) {
        imagePath = `/${bucket}/${imagePath}`
      } else if (!imagePath.startsWith(`/${bucket}/`)) {
        imagePath = `/${bucket}/${imagePath.replace(/^\/+/, '')}`
      }
      return imagePath
    },
    resolveImageUrl(image) {
      if (!image) return ''
      const s = String(image).trim()
      if (/^(https?:)?\/\//i.test(s)) return s
      if (s.startsWith('/api/file/')) return s
      if (/^\/[A-Za-z0-9_-]+\//.test(s)) {
        try {
          const { getMinioUrl } = require('@/utils/minio')
          return getMinioUrl(s)
        } catch (_) {
          const base = process.env.VUE_APP_MINIO_URL || 'http://127.0.0.1:9000'
          return `${base.replace(/\/$/, '')}${s}`
        }
      }
      return s
    },
    removeQuestionImage() {
      this.questionForm.image_paths = '[]'
    },
    buildQuestionPayload() {
      const payload = { ...this.questionForm }
      const primaryImage = this.getPrimaryImagePath(this.questionForm)
      payload.image_paths = primaryImage ? JSON.stringify([primaryImage]) : '[]'
      if (Object.prototype.hasOwnProperty.call(payload, 'image')) {
        delete payload.image
      }
      return payload
    },
    beforeQuestionImageUpload(file) {
      const isImage = /image\//.test(file.type)
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isImage) {
        this.$message.error('只能上传图片文件')
        return false
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 2MB')
        return false
      }
      return true
    },
    async uploadQuestionImage(option) {
      this.imageUploading = true
      try {
        const bucket = 'amc-question-test'
        const res = await uploadToBucket(option.file, bucket)
        let imagePath = res?.data?.path || res?.data?.url || res?.data || res?.path || res?.url || ''
        if (!imagePath) {
          throw new Error('上传成功但未返回图片地址')
        }
        imagePath = this.normalizeStoredImagePath(imagePath)
        this.questionForm.image_paths = JSON.stringify([imagePath])
        this.$message.success('图片上传成功')
        option.onSuccess && option.onSuccess(res)
      } catch (error) {
        this.$message.error('图片上传失败：' + (error.message || '未知错误'))
        option.onError && option.onError(error)
      } finally {
        this.imageUploading = false
      }
    },
    async loadFeedbackList() {
      this.loading = true
      try {
        let response
        if (this.filterStatus !== null) {
          response = await getFeedbackByStatus(this.filterStatus)
        } else {
          response = await getAllFeedback()
        }
        this.feedbackList = response.data || []

        // 如果有类型筛选
        if (this.filterType !== null) {
          this.feedbackList = this.feedbackList.filter(item => item.feedbackType === this.filterType)
        }
      } catch (error) {
        this.$message.error('加载反馈列表失败')
      } finally {
        this.loading = false
      }
    },

    async loadStatistics() {
      try {
        const response = await getStatistics()
        this.statistics = response.data || {}
      } catch (error) {
        console.error('加载统计信息失败', error)
      }
    },

    async handleFeedback(row) {
      this.currentFeedback = row
      this.handleForm.feedbackId = row.id
      this.handleForm.status = row.status === 0 ? 2 : row.status
      this.handleForm.handlerNote = row.handlerNote || ''
      this.questionForm = {
        id: null,
        contentCn: '',
        contentEn: '',
        optionsCn: '',
        optionsEn: '',
        answer: '',
        analysisCn: '',
        analysisEn: '',
        image_paths: '[]',
        knowledge: '',
        year: '',
        difficulty: ''
      }
      this.handleDialogVisible = true
      this.questionLoading = true
      try {
        const res = await getQuestionById(row.amcQuestionId)
        if (res.code === 1 || res.code === 200) {
          this.questionForm = this.normalizeQuestionForm({ ...this.questionForm, ...(res.data || {}) })
        } else {
          this.$message.error('获取题目详情失败：' + (res.msg || '未知错误'))
        }
      } catch (error) {
        this.$message.error('获取题目详情失败：' + (error.message || '未知错误'))
      } finally {
        this.questionLoading = false
      }
    },

    async openHandleDialog(row) {
      this.detailMode = false
      await this.handleFeedback(row)
    },

    async submitHandle() {
      if (!this.handleForm.handlerNote) {
        this.$message.warning('请输入处理备注')
        return
      }

      if (!this.questionForm.id) {
        this.$message.warning('题目详情尚未加载完成，暂时无法处理')
        return
      }

      this.submitting = true
      try {
        const questionRes = await updateQuestion(this.buildQuestionPayload())
        if (!(questionRes.code === 1 || questionRes.code === 200)) {
          this.$message.error('题目修改失败：' + (questionRes.msg || '未知错误'))
          return
        }
        await handleFeedback(this.handleForm)
        this.$message.success('题目修改并处理成功')
        this.handleDialogVisible = false
        this.loadFeedbackList()
        this.loadStatistics()
      } catch (error) {
        this.$message.error('处理失败：' + (error.message || '未知错误'))
      } finally {
        this.submitting = false
      }
    },

    async viewDetail(row) {
      this.detailMode = true
      await this.handleFeedback(row)
    },

    async viewQuestion(questionId) {
      // 打开题目编辑对话框
      this.editQuestionDialogVisible = true
      this.questionLoading = true

      try {
        const res = await getQuestionById(questionId)
        if (res.code === 1 || res.code === 200) {
          this.questionForm = this.normalizeQuestionForm({ ...res.data })
        } else {
          this.$message.error('获取题目详情失败：' + (res.msg || '未知错误'))
        }
      } catch (error) {
        this.$message.error('获取题目详情失败：' + (error.message || '未知错误'))
      } finally {
        this.questionLoading = false
      }
    },

    async saveQuestion() {
      this.savingQuestion = true
      try {
        const res = await updateQuestion(this.buildQuestionPayload())
        if (res.code === 1 || res.code === 200) {
          this.$message.success('题目修改成功！')
          this.editQuestionDialogVisible = false
        } else {
          this.$message.error('题目修改失败：' + (res.msg || '未知错误'))
        }
      } catch (error) {
        this.$message.error('题目修改失败：' + (error.message || '未知错误'))
      } finally {
        this.savingQuestion = false
      }
    },

    getTypeName(type) {
      const typeMap = {
        1: '题干问题',
        2: '选项问题',
        3: '图片问题',
        4: '解析问题',
        5: '答案问题',
        6: '其他问题'
      }
      return typeMap[type] || '未知'
    },

    getTypeTagType(type) {
      const typeMap = {
        1: 'primary',
        2: 'success',
        3: 'warning',
        4: 'info',
        5: 'danger',
        6: ''
      }
      return typeMap[type] || ''
    },

    getStatusName(status) {
      const statusMap = {
        0: '待处理',
        1: '处理中',
        2: '已处理',
        3: '已忽略'
      }
      return statusMap[status] || '未知'
    },

    getStatusType(status) {
      const statusMap = {
        0: 'warning',
        1: 'primary',
        2: 'success',
        3: 'info'
      }
      return statusMap[status] || ''
    },

    getPriorityName(priority) {
      const priorityMap = {
        1: '低',
        2: '中',
        3: '高'
      }
      return priorityMap[priority] || '中'
    },

    getPriorityType(priority) {
      const priorityMap = {
        1: 'info',
        2: '',
        3: 'danger'
      }
      return priorityMap[priority] || ''
    },

    formatTime(timeString) {
      if (!timeString) return ''
      return new Date(timeString).toLocaleString('zh-CN')
    }
  }
}
</script>

<style scoped>
.feedback-management {
  padding: 20px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.statistics {
  display: flex;
  gap: 10px;
}

.filter-bar {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
</style>
